import { useTranslations } from '@vocab/react';
import { Box, List, Stack, Text, TextLink } from 'braid-design-system';

import { ManUsingComputerSvg } from '../../SVG';
import { useAppConfig } from '../App/useAppConfig';
import ResultTemplate from '../Recommendations/ResultTemplate/ResultTemplate';

import translations from './.vocab';

interface ErrorProps {
  'data-automation'?: string;
}

const Error = (props: ErrorProps) => {
  const { 'data-automation': dataAutomation } = props;
  const { t } = useTranslations(translations);
  const { contactUsUrl } = useAppConfig();
  return (
    <ResultTemplate
      heading={t('Can we try that again?')}
      description={
        <Box padding="large">
          <Stack space="large">
            <Text>{t('Bear with us, we’re having technical issues.')}</Text>
            <Stack space="small">
              <Text>{t('Try:')}</Text>
              <List space="small">
                <Text>{t('Refreshing the page')}</Text>
                <Text>{t('Clearing your browser history')}</Text>
              </List>
            </Stack>
            <Text>
              {t('If the problem continues, please contact us', {
                Link: (children) => (
                  <TextLink href={contactUsUrl || '/'} weight="weak">
                    {children}
                  </TextLink>
                ),
              })}
            </Text>
          </Stack>
        </Box>
      }
      Illustration={ManUsingComputerSvg}
      data-automation={dataAutomation}
    />
  );
};

export default Error;
